import dynamic from 'next/dynamic';
import type { FC } from 'react';

import { useMdsWithRanking } from '@/domains/productDiscovery/ArticleReviews/modules/mdRankingPlaylist/hooks/useMDRankingPlaylist';

const MDRankingPlaylist = dynamic<React.PropsWithChildren<unknown>>(
  () =>
    import(
      '@/domains/productDiscovery/ArticleReviews/modules/mdRankingPlaylist/MDRankingPlaylist'
    ).then((mod) => mod.MDRankingPlaylist),
  {
    ssr: false,
    loading: () => <div style={{ height: 425 + 16 }} />,
  },
);

export const DynamicMDRankingPlaylist: FC = () => {
  const isMDRankingPlaylistAvailable = !!useMdsWithRanking().length;
  return isMDRankingPlaylistAvailable ? <MDRankingPlaylist /> : null;
};

DynamicMDRankingPlaylist.displayName = 'DynamicMDRankingPlaylist';
